import { CanActivateChildFn, Router } from '@angular/router';
import { inject } from '@angular/core'
import { ApiService } from '../services/api.service'
import { filter, map, take } from 'rxjs'

export const userInfoLoadedGuard: CanActivateChildFn = (childRoute, state) => {
  const api = inject(ApiService);
  const router = inject(Router);

  if (state.url === '/login-error') return true;
  if (state.url.startsWith('/login')) return true;

  return api.userInfo.pipe(
    take(1),
    map(userInfo => {
      if (userInfo && userInfo.id) {
          // const redirectUrl = sessionStorage.getItem('redirect');
          // if(redirectUrl){
          //     sessionStorage.removeItem('redirect');
          //     location.href = redirectUrl
          // }
        return true;
      }
      if (api.hasLoginError) {
        return router.parseUrl('/login-error');
      }
      return true;
    })
  );
};
